
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/terms/referral-terms",
      function () {
        return require("private-next-pages/terms/referral-terms/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/terms/referral-terms"])
      });
    }
  